import React from "react";

import { Container, Modal, Stack, Button } from "@mui/material";
import DeleteForeverIcon from '@mui/icons-material/DeleteForeverRounded';

const HoaPropertyViolationDeleteListItem = ({
	open, 
	onClose,
	handleDelete
}: any) => {
	return (
		<Modal open={open} onClose={onClose}>
			<Container
				style={{
					background: "white",
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "548px",
					maxHeight: "645px",
					overflow: "auto",
					borderRadius: "8px 8px 0px 0px",
					padding: "0px",
				}}
			>
				<div className="modal-wrapper-doc">
					<Stack 
						style={{ 
							alignItems: "center",
							padding: '12px 24px',
							gap: '12px',	
						}}
						direction={"row"}
						spacing={1}
						justifyContent="flex-between">
						<DeleteForeverIcon 
							style={{color: '#F44336', fontSize: '58px', border: "1px solid #EF5350", borderRadius: "50%", padding: '10px'}}/>
						<div>
							<h2 style={{color: '#3E3E3E'}}>Are you sure you want to delete?</h2>
							<p style={{color: '#787878'}}>This item will be deleted forever</p>
						</div>
					</Stack>

					<Stack
						style={{ marginTop: "24px" }}
						direction={"row"}
						spacing={1}
						justifyContent="flex-end"
					>
						<Button onClick={() => onClose()} variant="outlined">
							Cancel
						</Button>
						<Button onClick={handleDelete} variant="contained">
							Delete
						</Button>
					</Stack>
				</div>
			</Container>
		</Modal>
	)
}

export default HoaPropertyViolationDeleteListItem;